import http from "../http-common";

const getAll = (type) => {
  const params = {};
  if (type) {
    params.type = type;
  }
  return http.get("/resources", {params});
};

/**
 * Fetch a list of provider resources with optional server-side filtering.
 *
 * Supported options:
 *   - page:     1-indexed page number. When provided, the server returns a
 *               paginated payload `{ items, total, page, pageSize, totalPages }`.
 *               When omitted, the server returns a plain array of all matches.
 *   - pageSize: items per page (default 20 on the server, capped server-side).
 *   - keyword:  case-insensitive substring search across name/address/specialty/etc.
 *   - type:     filter by provider type ('doctor', 'pharmacy', 'hospital', ...).
 *   - status:   filter by status (e.g., 'active').
 *   - fields:   when `summary`, returns only list-display fields (id, name, specialty, address, etc.).
 */
const listResources = ({ page, pageSize, keyword, type, status, fields } = {}) => {
  const params = {};
  if (page != null && page !== '') params.page = page;
  if (pageSize != null && pageSize !== '') params.pageSize = pageSize;
  if (keyword != null && `${keyword}`.trim() !== '') params.keyword = `${keyword}`.trim();
  if (type) params.type = type;
  if (status) params.status = status;
  if (fields != null && `${fields}`.trim() !== '') params.fields = `${fields}`.trim();
  return http.get("/resources", { params });
};

const createNewResource = (data) => {
  data.status = 'active';
  return http.post('/resources', data);
};

const updateResource = (id, data) => {
  return http.put(`/resources/${id}`, data);
}

const disableResource = (id, data) => {
  return http.put(`/resources/${id}/disable`, data);
}

const getResource = (id) => {
  return http.get(`/resources/${id}`);
}

const deleteResource = (id) => {
  return http.delete(`/resources/${id}`)
}

const resourceOptionList = [
  'Family Medicine (PCP)',
  'Acupuncture',
  'Allergy & Asthma',
  'Audiology',
  'Behavior Health/Social Worker',
  'Bloodwork',
  'Botox Therapy',
  'Breast Surgery',
  'Cardiology',
  'Cardiovascular',
  'Colon & Rectal Surgery',
  'Dentist',
  'Dermatology',
  'Dialysis',
  'Endocrinology & Diabetes',
  'Endodontist',
  'Endoscopy Center',
  'Otolaryngology (ENT)',
  'Eye Surgery Center',
  'Gastroenterology',
  'General Surgery',
  'GYN Oncology',
  'Head & Neck Surgery',
  'Health Boutique',
  'Hearing Aids',
  'Hematology & Oncology',
  'Hepatology',
  'Hospital',
  'Infectious disease',
  'Internal Medicine',
  'Medical Center',
  'Lab',
  'Modified Barium Swallow (MBS) Study',
  'Medical Supply',
  'Nephrology',
  'Neuro Surgeon',
  'Neurology',
  'OB/GYN',
  'Optometry (OD)',
  'Oncology',
  'Oncology Center',
  'Ophthalmology',
  'Ophthalmology (Retina Specialist)',
  'Oral Surgery',
  'Orthopaedic',
  'Osteopath',
  'Pain Management',
  'Periodontist',
  'Pharmacy',
  'Physical Therapy',
  'Physical, Occupational, & Speech Therapy',
  'Podiatry',
  'Psychiatry',
  'Pulmonology',
  'Radiation Oncology',
  'Radiology',
  'Rehabilitation',
  'Rheumatology',
  'Sleep Medicine',
  'Sleep Study',
  'Substance Abuse Treatment',
  'Sports Medicine',
  'Surgery',
  'Surgery Center',
  'Thoracic Surgery',
  'Traditional Chinese Medicine',
  'Urgent Care',
  'Urogynecology',
  'Urology',
  'Vascular and Vein',
  'Vascular & Interventional Radiologist',
  'Weight Loss / GYM',
  'Wound Clinic'
];

export const ResourceService = {
  getAll,
  listResources,
  createNewResource,
  updateResource,
  disableResource,
  getResource,
  deleteResource,
  resourceOptionList
};
